"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseTransition = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var transition_1 = require("../_util/transition");
var BaseTransition_1 = require("./BaseTransition");
function CollapseTransition(_a) {
    var height = _a.height, timeout = _a.timeout, rest = tslib_1.__rest(_a, ["height", "timeout"]);
    var enterTimeout;
    var exitTimeout;
    if (typeof timeout === "number") {
        enterTimeout = timeout;
        exitTimeout = timeout;
    }
    else if (timeout && typeof timeout === "object") {
        enterTimeout = timeout.enter;
        exitTimeout = timeout.exit;
    }
    return (react_1.default.createElement(BaseTransition_1.BaseTransition, tslib_1.__assign({}, transition_1.collapse(height, enterTimeout, exitTimeout), rest)));
}
exports.CollapseTransition = CollapseTransition;
CollapseTransition.displayName = "CollapseTransition";
//# sourceMappingURL=CollapseTransition.js.map